// components/Application/SelfTrackingApplicationCard.jsx
import React from 'react';
import styles from './SelfTrackingApplicationCard.module.css';

const SelfTrackingApplicationCard = ({ application, onUpdate, onEdit, onWithdraw }) => {
  const getStatusColor = (status) => {
    switch (status) {
      case 'accepted': return '#22c55e';
      case 'rejected': return '#ef4444';
      case 'interview': return '#3b82f6';
      case 'waitlist': return '#f59e0b';
      default: return '#6b7280';
    }
  };

  const getStatusDisplay = (status) => {
    switch (status) {
      case 'accepted': return 'Moved Forward';
      case 'rejected': return 'Rejected';
      case 'interview': return 'Interview';
      case 'waitlist': return 'Waitlist';
      default: return status.charAt(0).toUpperCase() + status.slice(1);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'Not specified';
    return new Date(dateString).toLocaleDateString();
  };

  return (
    <div className={styles.applicationCard}>
      <div className={styles.cardHeader}>
        <h3 className={styles.positionTitle}>{application.positionTitle}</h3>
        <div 
          className={styles.statusBadge}
          style={{ backgroundColor: getStatusColor(application.status) }}
        >
          {getStatusDisplay(application.status)}
        </div>
      </div>

      <div className={styles.cardBody}>
        <div className={styles.institutionInfo}>
          <p className={styles.institution}>{application.institution}</p>
          {application.professorName && (
            <p className={styles.professor}>Prof. {application.professorName}</p>
          )}
        </div>

        {application.fields && application.fields.length > 0 && (
          <div className={styles.fields}>
            {application.fields.slice(0, 2).map((field, index) => (
              <span key={index} className={styles.fieldTag}>{field}</span>
            ))}
          </div>
        )}

        <div className={styles.applicationDetails}>
          <div className={styles.detailItem}>
            <span className={styles.detailLabel}>Applied:</span>
            <span className={styles.detailValue}>{formatDate(application.applicationDate)}</span>
          </div>
          {application.deadlineDate && (
            <div className={styles.detailItem}>
              <span className={styles.detailLabel}>Deadline:</span>
              <span className={styles.detailValue}>{formatDate(application.deadlineDate)}</span>
            </div>
          )}
        </div>

        {application.notes && (
          <div className={styles.notes}>
            <p>{application.notes}</p>
          </div>
        )}
      </div>

      <div className={styles.cardActions}>
        <button
          className={styles.editButton}
          onClick={() => onEdit(application)}
        >
          Edit
        </button>
        {application.applicationLink && (
          <a
            href={application.applicationLink}
            target="_blank"
            rel="noopener noreferrer"
            className={styles.linkButton}
          >
            View Application
          </a>
        )}
        <button
          className={styles.withdrawButton}
          onClick={() => onWithdraw(application._id)}
        >
          Delete
        </button>
      </div>
    </div>
  );
};

export default SelfTrackingApplicationCard;